import React from 'react';
import { loadRemote } from '@module-federation/enhanced/runtime';
import useAuth from '../hooks/useAuth';
import ccoeCommon from './components/ccoe-common';
import { generateMfePage, PROVIDER_PROPS } from './generateMfePage';
import { registerMfeRemote } from './remotes';
import useIsCcoeAdmin from './useIsCcoeAdmin';

// CCoE pages read org preferences and the viewer's admin status from the
// OrgPreferenceProvider that ccoe-common exports. Older ccoe-common builds don't
// export it; the page then renders unwrapped.
const loadOrgPreferenceProvider = async (): Promise<React.ComponentType<any> | undefined> => {
  try {
    registerMfeRemote(ccoeCommon);
    const common: any = await loadRemote(`${ccoeCommon.remote}/index`);
    return common?.OrgPreferenceProvider;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[CCOE MFE] Failed to load OrgPreferenceProvider from ccoe-common:', error);
    return undefined;
  }
};

export const generateCcoeMfePage = (componentName: string) => {
  const MfePage = generateMfePage(componentName, { loadProvider: loadOrgPreferenceProvider });

  const CcoeMfePage = (props: Record<string, unknown>) => {
    const { jwt } = useAuth();
    const { isAdmin, isResolving } = useIsCcoeAdmin(jwt);
    return <MfePage {...props} {...{ [PROVIDER_PROPS]: { isAdmin, isAdminResolving: isResolving } }} />;
  };

  return CcoeMfePage;
};
